export default "__VITE_ASSET__Bgitmzs3__"